import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./sections/Navbar";
import Footer from "./sections/Footer";

if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

const Layout = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    requestAnimationFrame(() => window.scrollTo(0, 0));
  }, [pathname]);

  return (
    <div className="min-h-screen bg-[#070A0F] text-white">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
